// import { Grid, Paper, Typography } from "@mui/material";
// import React from "react";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import WSDashboardCard from "../../../Components/CardListing/WSDashboardCard";
// import WSDateField from "../../../Components/DateField/WSDateField";
// import WSSelectField from "../../../Components/Select/WSSelect";
// import dashboardBg from "../../../images/dashboard-bg-card.svg";
// import { useForm } from "react-hook-form";
// import { useDispatch } from "react-redux";
// import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
// import {
//   IsSmallScreen,
//   updateMainHeader,
// } from "../../../commonFunctions/CommonFunctions";
// import { useNavigate } from "react-router-dom";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import config from "../../../Config/clientConfig.json";
// import { LabRecentOrders } from "./LabRecentOrders";
// import WeeklyChart from "./SummarySalesChart";
// import { LabRecentNotification } from "./LabRecentNotification";
// import LabProductsCard from "./LabProductCard";

// export const LabOverview: React.FC<any> = React.memo((props) => {
//   const { control, register } = useForm();
//   const navigate = useNavigate();
//   const isMobile = IsSmallScreen();
//   const dispatch = useDispatch();
//   const { showMessage } = useSnackbar();

//   updateMainHeader("Dashboard");
//   breadCrumbsStore.updateBreadCrumbs([{ Overview: "/lab-overview" }]);
//   return (
//     <>
//       {/* ---------------- Welcome Section ---------------- */}
//       <Paper
//         elevation={0}
//         sx={{
//           p: 3,
//           mt: 1,
//           mb: 2,
//           borderRadius: 3,
//           backgroundImage: `url(${dashboardBg})`,
//           backgroundSize: "cover",
//           backgroundRepeat: "no-repeat",
//           backgroundPosition: "center",
//         }}
//       >
//         <Grid container spacing={2}>
//           <Grid item xs={12} sm={8}>
//             <Typography
//               variant="h5"
//               fontWeight={600}
//               style={{ color: "#098963" }}
//             >
//               Hello, Biolab Advanced Diagnostic Centre 🖐️
//             </Typography>
//             <Typography sx={{ color: "#022219", mt: 0.5 }}>
//               “Get a quick snapshot of your lab’s performance today{" "}
//             </Typography>
//             <Typography sx={{ color: "#828584", mt: 1 }}>
//               Monday, 23-06-2025
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={2}>
//             <WSSelectField
//               rules={{ required: true }}
//               {...register("days")}
//               id="days"
//               control={control}
//               label=""
//               name="days"
//               isInGridFilter={true}
//               options={config.dayConfig.staticOptionData}
//             />
//           </Grid>
//           <Grid item xs={12} sm={2}>
//             <WSDateField
//               id={"dob"}
//               name={"dob"}
//               label={"DOB"}
//               dateFormat="DD-MM-YYYY"
//               control={control}
//               isInGridFilter={true}
//               defaultValue={null}
//               rules={{ required: false }}
//             />
//           </Grid>
//           <Grid item xs={12} sm={3}>
//             <WSDashboardCard
//               title="Today Orders"
//               value="100"
//               percentage="+2.5%"
//               bottomIcon={<WSIcons.TrendingUp />}
//               icon={<WSIcons.ShoppingCartIcon sx={{ color: "#098963" }} />}
//             />
//           </Grid>

//           <Grid item xs={12} sm={3}>
//             <WSDashboardCard
//               title="Pending Collections"
//               value="40"
//               percentage="+2.5%"
//               bottomIcon={<WSIcons.TrendingUp />}
//               icon={<WSIcons.ShoppingCartIcon sx={{ color: "#098963" }} />}
//             />
//           </Grid>

//           <Grid item xs={12} sm={3}>
//             <WSDashboardCard
//               title="Reports Pending"
//               value="20"
//               percentage="+2.5%"
//               bottomIcon={<WSIcons.TrendingUp />}
//               icon={<WSIcons.ShoppingCartIcon sx={{ color: "#098963" }} />}
//             />
//           </Grid>

//           <Grid item xs={12} sm={3}>
//             <WSDashboardCard
//               title="Cancellations"
//               value="40"
//               percentage="+2.5%"
//               bottomIcon={<WSIcons.TrendingUp />}
//               icon={<WSIcons.ShoppingCartIcon sx={{ color: "#098963" }} />}
//             />
//           </Grid>
//           <Grid item xs={12} sm={3}>
//             <WSDashboardCard
//               title="Low Stock Alerts"
//               value="40"
//               percentage="+2.5%"
//               bottomIcon={<WSIcons.TrendingUp />}
//               icon={<WSIcons.ShoppingCartIcon sx={{ color: "#098963" }} />}
//             />
//           </Grid>
//           <Grid item xs={12} sm={3}>
//             <WSDashboardCard
//               title="Earnings"
//               value="40"
//               percentage="+2.5%"
//               bottomIcon={<WSIcons.TrendingUp />}
//               icon={<WSIcons.ShoppingCartIcon sx={{ color: "#098963" }} />}
//             />
//           </Grid>
          
//         </Grid>
//       </Paper>
//       <Grid container spacing={2}>
//         {/* First Column */}
//         <Grid item xs={12} sm={8}>
//           <Grid container spacing={2} direction="column">
//             <Grid item>
//               {" "}
//               <LabRecentOrders />
//             </Grid>
//             <Grid item>
//               {" "}
//               <WeeklyChart />
//             </Grid>
//           </Grid>
//         </Grid>

//         {/* Second Column */}
//         <Grid item xs={12} sm={4}>
//           <Grid container spacing={2} direction="column">
//             <Grid item>
//               {" "}
//               <LabRecentNotification />
//             </Grid>
//             <Grid item>
//               {" "}
//               <LabProductsCard />
//             </Grid>
//           </Grid>
//         </Grid>
//       </Grid>
//     </>
//   );
// });



import { Grid, Paper, Typography } from "@mui/material";
import React, { useState, useEffect, useCallback } from "react";
import { WSIcons } from "../../../commonFunctions/iIcons";
import WSDashboardCard from "../../../Components/CardListing/WSDashboardCard";
import dashboardBg from "../../../images/dashboard-bg-card.svg";
import { useDispatch } from "react-redux";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import {
  IsSmallScreen,
  updateMainHeader,
  getLocalValue,
  LoacalVariables,
} from "../../../commonFunctions/CommonFunctions";
import { useNavigate } from "react-router-dom";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import { LabRecentOrders } from "./LabRecentOrders";
import LabOrdersChart from "./LabOrdersChart";
import LabOrderStatusCard, { OrderStatusItem } from "./LabOrderStatusCard";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import { matchesOutcome, OutcomeFilter } from "../labOrderOutcome";
import LabProductsCard from "./LabProductCard";
import http from "../../../commonFunctions/httpClient";

interface LabDashboardData {
  totalOrders: number;
  cancelled: number;
  fulfilled: number;
  refund: number;
  delays: number;
  totalTechnicians: number;
}

// Booking counts use the same rules as the order lists, so each card matches the list it opens
const getOrderCounts = (bookings: any[]) => {
  const count = (filter: OutcomeFilter) => bookings.filter((b) => matchesOutcome(b, filter)).length;
  return {
    totalOrders: bookings.length,
    cancelled: count("cancelled"),
    fulfilled: count("fulfilled"),
    refund: count("refund"),
    delays: count("delayed"),
  };
};

// Replace your ENTIRE LabOverview component with this:
export const LabOverview: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const isMobile = IsSmallScreen();
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();

  const [labId, setLabId] = useState<string>("");
  const [dashboardData, setDashboardData] = useState<LabDashboardData>({
    totalOrders: 0,
    cancelled: 0,
    fulfilled: 0,
    refund: 0,
    delays: 0,
    totalTechnicians: 0,
  });
  const [bookings, setBookings] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  // Name from the login response (stored in localStorage at login)
  const labName = getLocalValue(LoacalVariables.Name) || "there";

  // Today's date, e.g. "Wednesday, 16-06-2026"
  const now = new Date();
  const todayLabel = `${now.toLocaleDateString("en-US", { weekday: "long" })}, ${String(
    now.getDate()
  ).padStart(2, "0")}-${String(now.getMonth() + 1).padStart(2, "0")}-${now.getFullYear()}`;

  // Load labId on mount
  useEffect(() => {
    const userId = getLocalValue(LoacalVariables.UserId);
    if (userId) {
      console.log('🚀 Loading labId:', userId);
      setLabId(userId);
    }
  }, []);

  // Fetch dashboard data: order counts from bookings, technician count from summary
  const fetchDashboardData = useCallback(async () => {
    if (!labId) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const [bookingsResult, technicianResult] = await Promise.allSettled([
        http.get(`lab/LabBooking/lab/${labId}`),
        http.get(`lab/Technician/${labId}/Labtechnician-summary`),
      ]);

      const bookingsResponse: any = bookingsResult.status === "fulfilled" ? bookingsResult.value : null;
      const bookings: any[] = Array.isArray(bookingsResponse?.data) ? bookingsResponse.data : [];

      const technicianResponse: any = technicianResult.status === "fulfilled" ? technicianResult.value : null;
      const totalTechnicians = technicianResponse?.data?.totalDeliveryPersons || 0;

      setBookings(bookings);
      setDashboardData({ ...getOrderCounts(bookings), totalTechnicians });

      if (bookingsResult.status === "rejected" || technicianResult.status === "rejected") {
        showMessage("Some dashboard data could not be loaded", "error");
      }
    } catch (error: any) {
      console.error("LAB DASHBOARD ERROR:", error);
      showMessage("Failed to load dashboard data", "error");
    } finally {
      setLoading(false);
    }
  }, [labId, showMessage]);

  useEffect(() => {
    if (labId) {
      fetchDashboardData();
    }
  }, [labId, fetchDashboardData]);

  updateMainHeader("Dashboard");
  breadCrumbsStore.updateBreadCrumbs([{ Overview: "/lab-overview" }]);


  // Each status opens the order list filtered to exactly the orders it counts;
  // colours match the status chips on the order lists
  const statusItems: OrderStatusItem[] = [
    { label: "Cancelled", value: dashboardData.cancelled, color: "#D32F2F", onClick: () => navigate("/lab-orders/history?outcome=cancelled") },
    { label: "Fulfilled", value: dashboardData.fulfilled, color: "#098963", onClick: () => navigate("/lab-orders/history?outcome=fulfilled") },
    { label: "Refund", value: dashboardData.refund, color: "#7B1FA2", onClick: () => navigate("/lab-orders/history?outcome=refund") },
    { label: "Delays", value: dashboardData.delays, color: "#E39B1B", onClick: () => navigate("/lab-orders/list?outcome=delayed") },
  ];

  if (loading) {
    return (
      <Paper sx={{ p: 3, mt: 1, mb: 2, borderRadius: 3, minHeight: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography>Loading dashboard...</Typography>
      </Paper>
    );
  }

  return (
    <>
      <Paper elevation={0} sx={{
        p: 3, mt: 1, mb: 2, borderRadius: 3,
        backgroundImage: `url(${dashboardBg})`,
        backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center",
      }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h5" fontWeight={600} style={{ color: "#098963" }}>
              Hello, {labName} 🖐️
            </Typography>
            <Typography sx={{ color: "#022219", mt: 0.5 }}>
              Get a quick snapshot of your lab's performance today
            </Typography>
            <Typography sx={{ color: "#828584", mt: 1 }}>
              {todayLabel}
            </Typography>
          </Grid>

          {/* Total orders | status breakdown | technicians */}
          <Grid item xs={12} sm={6} md={3}>
            <WSDashboardCard
              title="Total Orders"
              value={dashboardData.totalOrders.toString()}
              icon={<WSIcons.ShoppingCartIcon sx={{ color: "#098963" }} />}
              onClick={() => navigate("/lab-orders/list?outcome=all")}
              height="100%"
            />
          </Grid>
          <Grid item xs={12} md={6} sx={{ order: { xs: 3, md: 0 } }}>
            <LabOrderStatusCard totalOrders={dashboardData.totalOrders} items={statusItems} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <WSDashboardCard
              title="Total Technicians"
              value={dashboardData.totalTechnicians.toString()}
              icon={<PeopleAltOutlinedIcon sx={{ color: "#2196f3" }} />}
              onClick={() => navigate("/lab-technician-manage/list")}
              height="100%"
            />
          </Grid>
        </Grid>
      </Paper>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={8}>
          <Grid container spacing={2} direction="column">
            <Grid item><LabRecentOrders /></Grid>
            <Grid item><LabOrdersChart bookings={bookings} /></Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={4}>
          <Grid container spacing={2} direction="column">
            <Grid item><LabProductsCard /></Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
});
